import React from 'react'
import './Tbl.css'

export default function TblCell({title, isWider=false, state='normal', maxWidth='360px', children}) {
  // TODO: Don't keep this here. Not belong.
  const stateColors = {
    'normal': 'inherit',
    'created': '#bbdd33',
    'sent': '#ee8',
    'email sending error': '#ff4040',
    'claimed': '#80ffff',
    'done': '#55cc11',
    'joined': '#44ee33'
  }

  const childComp = children ? children : title;

  const cellStyle = isWider ? 'tblCell wider' : 'tblCell';
  const myColor = stateColors[state];
  return (
    <div className={cellStyle} style={{color: myColor, maxWidth:maxWidth}}>{childComp}</div>
  )
}
